<!--
Author: TangChen
Date: 2018-09-06
Desc: 绘制资产信息底部，为公共组件
 -->
<template>
    <div class="comp-assets-fund comp">
        <el-row v-if="fundInfo.length <= 0" class="no-funds">
            <el-col :span="12" :offset="8">
                <span class="no-funds-img" />
                <div class="no-funds-box">
                    <p>您还没有购买产品哦，立即购买享受您的基金之旅吧! </p>
                    <el-button type="blue" size="small" v-on:click.once="$router.push({name:fundCate==='0'?'fund':'privatefund'})">
                        去看看
                    </el-button>
                </div>
            </el-col>
        </el-row>
        <el-table
            v-if="fundInfo.length > 0"
            :data="fundAll"
            style="width: 100%"
            :show-header="false"
            :row-key="getRowKeys"
            :expand-row-keys="expands"
            v-on:expand-change="expendTable"
        >
            <el-table-column label="基金信息" :width="isRisk>0?'780':'880'">
                <template slot-scope="scope">
                    <el-row class="fund-list">
                        <el-col :span="24" class="fund-tit">
                            <span v-if="scope.row.busitype === '1'" class="type-cla">{{ $cache.getDict('110336',scope.row.busitype) }}</span>
                            <span style="cursor: pointer;" v-on:click="gotoDetail(scope.row)">
                                <span>{{ scope.row.fundname+'('+(scope.row.fundcode === "515981" ? "515980" : scope.row.fundcode)+')' }}</span>
                                <i class="risk" :class="$util.riskCla(scope.row.risklevel)">{{ $cache.getDict('110143',scope.row.risklevel)+'风险' }}</i>
                            </span>
                        </el-col>
                        <el-col v-if="scope.row.busitype !== '1'" :span="5">
                            <span>{{ $util.fmtNum(scope.row.marketvalue) }}</span>
                            <p>持有资产(元)</p>
                        </el-col>
                        <el-col v-if="scope.row.busitype !== '1'" :span="5">
                            <span>{{ $util.fmtNum(scope.row.balancevol) }}</span>
                            <p>持有份额(份)</p>
                        </el-col>
                        <el-col v-if="scope.row.busitype !== '1'" :span="5">
                            <span>{{ $util.fmtNum(scope.row.costmoney) }}</span>
                            <p>投入本金(元)</p>
                        </el-col>
                        <el-col v-if="scope.row.busitype !== '1'" :span="4">
                            <span :class="scope.row.floatprofit>0.01?'add':(scope.row.floatprofit<=-0.01?'reduce':'')">{{ $util.fmtNum(scope.row.floatprofit) }}</span>
                            <p>持有收益(元)</p>
                        </el-col>
                        <el-col v-if="scope.row.busitype !== '1'" :span="5">
                            <span>{{ $util.fmtNum(scope.row.nav,4) }}</span>
                            <p>{{ '最新净值('+$util.fmtDate(scope.row.navdate)+')' }}</p>
                        </el-col>
                        <el-col v-if="scope.row.busitype === '1'" :span="19">
                            <span>{{ $util.fmtNum(scope.row.appamount) }}</span>
                            <p>交易金额</p>
                        </el-col>
                        <el-col v-if="scope.row.busitype === '1'" :span="5">
                            <span>{{ $util.fmtDate(scope.row.busidate) }}</span>
                            <p>交易时间</p>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
            <el-table-column type="expand" label="" width="100">
                <template slot-scope="props">
                    <el-form
                        v-for="(item,index) in props.row.fundArr"
                        :key="index"
                        label-position="left"
                        inline
                        class="demo-table-expand"
                    >
                        <div v-if="props.row.busitype !== '1'" class="all">
                            <el-form-item label="可用份额">
                                <span>{{ $util.fmtNum(item.availablevol) }}(份)</span>
                            </el-form-item>
                            <el-form-item v-if="!$util.isEmpty(item.defdividendmethod)" label="分红方式">
                                <span>{{ $cache.getDict('110001',item.defdividendmethod) }}&nbsp;&nbsp;&nbsp;&nbsp;<span v-if="item.fundtype!=='2' && item.fundbizflag.indexOf('a')>-1" class="like-a" v-on:click="changeDiv(item.fundcode,item.transid)">[修改分红方式]</span></span>
                            </el-form-item>
                            <el-form-item label="冻结份额">
                                <span>{{ $util.fmtNum(item.frozenvol) }}(份)</span>
                            </el-form-item>
                            <el-form-item label="累计收益">
                                <span>{{ $cache.getParams('is_zx')==='1'?$util.fmtNum(item.totalincome):$util.fmtNum(item.addincome) }}(元)</span>
                            </el-form-item>
                            <el-form-item v-if="item.channelid!=='--'&&!$util.isEmpty(item.channelid)" label="银行卡">
                                <span>{{ $cache.getDict('110080',item.channelid) + '[尾号'+item.bankcard.substr(-4,4)+']-'+$cache.getDict('110079',item.paycenterid) }}</span>
                            </el-form-item>
                            <el-form-item label="基金账号">
                                <span>{{ item.taaccountid }}</span>
                            </el-form-item>
                            <el-form-item v-if="item.yestincome!=='--'&&!$util.isEmpty(item.yestincome)" label="昨日收益">
                                <span>{{ $util.fmtNum(item.yestincome) }}(元)</span>
                            </el-form-item>
                            <el-form-item v-if="item.sourceflag==='2'&&item.distributorcode" label="销售机构">
                                <span>{{ $cache.getDict('110070',item.distributorcode) }}</span>
                            </el-form-item>
                        </div>
                        <div v-else class="all">
                            <el-form-item label="申请单号">
                                <span>{{ item.serialno }}</span>
                            </el-form-item>
                            <el-form-item label="变更方式">
                                <span>{{ item.chgtype==='0'?'产品':'客户' }}风险变动</span>
                            </el-form-item>
                        </div>
                    </el-form>
                </template>
            </el-table-column>
            <!--专户目前只在柜台交易，网上交易只展示持仓和基金详情-->
            <el-table-column v-if="type==='0' && !isSpecialFund" label="基金操作" prop="fundcode" align="right" :min-width="isRisk>0?'278px':'178px'">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.iswarn==='1'" type="text" size="small" class="red" v-on:click="callbackFn('P4',scope.row)">
                        <i class="fa fa-exclamation-triangle" />阅读风险警示
                    </el-button>
                    <el-tooltip v-if="scope.row.isBuy" class="item" effect="info" :content="scope.row.isBuy + ',不能追加购买'" placement="left">
                        <el-button type="lock" size="small">
                            追加购买
                        </el-button>
                    </el-tooltip>
                    <el-button v-else type="yellow" size="small" v-on:click="callbackFn('20,22',scope.row)">
                        追加{{ scope.row.isBuy===''?'购买':'认购' }}
                    </el-button>
                    <el-tooltip v-if="scope.row.isSell" class="item" effect="info" :content="scope.row.isSell" placement="left">
                        <el-button type="lock" size="small">
                            赎回
                        </el-button>
                    </el-tooltip>
                    <el-button v-else type="blue" size="small" v-on:click="callbackFn('24',scope.row)">
                        赎回
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column v-if="type==='1'" label="基金操作" prop="fundcode" align="center">
                <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.isChange" class="item" effect="info" :content="scope.row.isChange + ',不能转换'" placement="left">
                        <el-button type="lock" size="small">
                            转换
                        </el-button>
                    </el-tooltip>
                    <el-button v-else class="btn-fund" type="blue" size="small" v-on:click="callbackFn('36',scope.row)">
                        转换
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="分红方式修改" :visible.sync="dialogVisible" class="prop info-tips" width="480px">
            <div class="investor-tips">
                <div class="prompt-info">
                    <p class="clear">
                        <i class="el-icon-warning" /><span>您确定将当前基金分红方式修改为{{ $cache.getDict('110001',changeFund.defdividendmethod)+(isPwdCheck?'，输入交易密码进行修改':'') }}</span>
                    </p>
                </div>
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="37px"
                    size="small"
                >
                    <el-form-item v-if="isPwdCheck" label="" prop="tradepwd">
                        <el-input v-model="ruleForm.tradepwd" type="password" :maxlength="20" placeholder="请输入交易密码" />
                        <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="dialogVisible = false;ruleForm.tradepwd=''">
                    返回
                </el-button>
                <el-button type="primary" v-on:click="changeDivMethod()">
                    修改
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "AssetsFund",
    props: {
        fundInfo: {
            type: Array,
            default: ()=>{
                return [];
            },
            required: true
        },
        type: {
            type: String,
            default: "0"
        },
        isRisk: {
            type: Number,
            default: 0
        }
    },
    data () {
        return {
            fundAll: [],
            expands: [],
            userInfo: {},
            dialogVisible: false,
            isPwdCheck: false,
            ruleForm: {
                tradepwd: ""
            },
            fundCate: "0", // 0普通基金，1私募基金
            rules: {
                tradepwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            },
            changeFund: {},
            noSellFlag: true
        };
    },
    computed: {
        isSpecialFund(){
            return this.fundAll[0] && this.fundAll[0].fundtype === "4";
        }
    },
    watch: {
        fundInfo () {
            this.getNewFund();
        }
    },
    created () {
        this.isPwdCheck = this.$cache.getPwdCheck("29");
        this.userInfo = this.$cache.getUser();
    },
    methods: {
        gotoDetail(val){
            let params = {secondtype: val.fundcode,etfflag: val.etfflag};
            if(this.fundAll[0] && this.fundAll[0].fundtype === "4"){//专户基金跳网站详情需要查看公告
                params.watchcontrol = "1";
            }
            this.$util.toCompPage("/fund",params);
        },
        callbackFn (way, fund) {
            let moduleId = "";
            let flag = "0";
            if (way == "36" || way == "24") {
                moduleId = way;
            }else {
                if (fund.isBuy === "") {
                    moduleId = "22";
                }else {
                    moduleId = "20";
                }
            }
            if (moduleId == "20" || moduleId == "22" || moduleId == "36" || moduleId == "29") {
                flag = "0";
            }else {
                flag = "1";
            }
            // 申购 22 认购 20  转换36  赎回24
            this.$util.checkGtOcrModule(moduleId,flag, res => {
                if (res.checkFlag && this.userInfo.needOcrUpload === "1") {
                    this.$msgbox({
                        title: "证件未上传",
                        message: this.$createElement("div", null, [
                            this.$createElement(
                                "span",
                                null,
                                "您的证件资料还未上传，请先上传有效证件。"
                            )
                        ]),
                        showCancelButton: false,
                        confirmButtonText: "立即上传",
                        type: "warning",
                        customClass: "info-check",
                        beforeClose: (action, instance, done) => {
                            if (action === "confirm") {
                                this.$router.push({
                                    name: "ocrinfoupd",
                                    query: {certificatetype: "1"}
                                });
                                done();
                            } else {
                                done();
                            }
                        }
                    });
                } else {
                    this.$emit("fund-continue", way, fund);
                }
            });
        },
        // 修改分红方式
        changeDivMethod () {
            const _this = this;
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    let _pwd = "";
                    if (_this.isPwdCheck) {
                        _pwd = _this.$util.enc(_this.ruleForm.tradepwd);
                    }
                    const _data = {
                        branchcode: _this.changeFund.branchcode,
                        transactionaccountid: _this.changeFund.transid,
                        tano: _this.changeFund.tano,
                        fundcode: _this.changeFund.fundcode,
                        sharetype: _this.changeFund.sharetype,
                        defdividendmethod: _this.changeFund.defdividendmethod,
                        dividendmethod: _this.changeFund.defdividendmethod,
                        tradepwd: _pwd
                    };
                    this.$util.request("trade/divide/modify", _data, "POST").then(res => {
                        if (res.data) {
                            _this.dialogVisible = false;
                            _this.ruleForm.tradepwd = "";
                            this.$message({
                                type: "success",
                                message: "您的" + this.changeFund.fundname + "基金修改分红申请已提交成功，等待确认"
                            });
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        // 获取修改分红方式基金信息
        changeDiv (fundcode, val) {
            const _c = this.fundInfo.filter(item => {
                return item.fundcode === fundcode;
            })[0];
            if (_c) {
                const _x = _c.fundArr.filter(item => {
                    return item.transid === val;
                })[0];
                this.changeFund = Object.assign({}, _x);
                this.changeFund.defdividendmethod = this.changeFund.defdividendmethod === "0" ? "1" : "0";
                this.dialogVisible = true;
            }
        },
        async getNewFund () {
            this.fundAll = [];
            for(let index = 0; index < this.fundInfo.length; index++){
                const _x = Object.assign({}, this.fundInfo[index]);
                _x.index = index + 1;
                const resR = await this.$util.request("short/asset/detailDX", {fundcode: _x.fundcode}, "GET");
                const resData = resR.data;
                const detailData = [];
                resData.forEach(function (item) {
                    if(item.preavailbal != 0){
                        detailData.push(item);
                    }
                });
                // 如果结果中数据为空，说明该产品不是短期理财产品
                if(resData.length == 0){
                    this.noSellFlag = true;
                }else{
                    detailData.sort(function (a, b) {
                        return b.finaldate - a.finaldate; // 降序排列
                    });
                    const todayTime = this.$cache.getUser().busidate;
                    if(detailData[0] && detailData[0].finaldate > todayTime){
                        this.noSellFlag = false;
                    }
                }
                if (this.type === "0" && this.noSellFlag) {
                    _x.isBuy = this.$util.checkBuy(_x.fundstatus);
                    _x.isSell = this.$util.checkSell(_x);
                } else {
                    _x.isChange = this.$util.checkChange(_x);
                }
                this.fundAll.push(_x);
            }
        },
        getFundByCode(arr, fundcode) {
            let _arr = [];
            arr.forEach((fund, index) => {
                if (fund.fundcode = fundcode) {
                    _arr.push(fund);
                }
            });
            return _arr;
        },
        // 指定每行row-key
        getRowKeys (row) {
            return row.index;
        },
        // 展开指定行
        expendTable (row) {
            if (row.index !== this.expands[0]) {
                this.expands = [];
                this.expands.push(row.index);
            } else {
                this.expands = [];
            }
        }
    }
};
</script>
<style lang="scss">
  @import '../../assets/css/varibles';
  .comp-assets-fund {
    .el-table__expand-icon {
      margin-top: 20px;
    }
      .redemp-btn{
          margin-left: 3%;
      }
    td.is-right,td.is-center {
      .cell {
        margin-top: 20px;
      }
    }
    .prompt-info{
      span{float: right;display: inline-block;width: 405px;}
    }
    .el-button.el-button--yellow,
    .el-button.el-button--yellow:hover,
    .el-button.el-button--yellow:focus {
        color: $text-color6;
        background-color: $color-a-s;
        border-color: $color-a-s;
    }

    .el-button.el-button--blue,
    .el-button.el-button--blue:hover,
    .el-button.el-button--blue:focus {
        color: $text-color6;
        background-color: $color-a;
        border-color: $color-a;
    }
  }
</style>
